import type { TZaiChatParamsKey } from './zai.types'

export const ZAI_CHAT_PARAMS_KEY = {
  threadId: 'thread_id',
  threadPrompt: 'thread_prompt',
  threadPromptPage: 'thread_prompt_page',
  redirectUrl: 'redirect_url',
  promptVariant: 'prompt_variant',
  ragEnabled: 'rag_enabled',
  theme: 'theme',
  quickPromptId: 'quick_prompt_id',
} as const satisfies Record<string, TZaiChatParamsKey>

export const ZAI_QUESTION_TYPE = {
  PROMPT: 'prompt' as const,
  SIMPLE: 'simple' as const,
}

// Shared between zai-side-chat (listener) and zai-side-chat-button (dispatcher)
export const ZAI_SIDE_CHAT_TOGGLE_EVENT = 'zai-side-chat:toggle'
